import { z } from 'zod';
import { idSchema } from './common.ts';

// Brand kit (docs/09 §D): one per org, stored in orgs.brand_json. Feeds template
// auto-theming, the overlay default logo, image-gen prompts, and assistant copy tone.
// Every field is optional/empty by default so a fresh org has a well-formed empty kit.

// Up to 6 brand colors, each a #RGB / #RRGGBB hex string.
const hexColorSchema = z
  .string()
  .regex(/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/, 'expected a #RGB or #RRGGBB hex color');

export const brandKitSchema = z.object({
  // A media id (image) used as the brand logo. Null when unset.
  logo_media_id: idSchema.nullable(),
  colors: z.array(hexColorSchema).max(6),
  font: z.string().max(120).nullable(),
  tone: z.string().max(400).nullable(),
});
export type BrandKit = z.infer<typeof brandKitSchema>;

// PATCH /v1/org/brand — every field optional; omitted fields are left unchanged,
// an explicit null clears logo/font/tone. `logo_media_id` is validated against the
// media library (org-owned, ready image) in the service, not here.
export const updateBrandKitSchema = z
  .object({
    logo_media_id: idSchema.nullish(),
    colors: z.array(hexColorSchema).max(6).optional(),
    font: z.string().max(120).nullish(),
    tone: z.string().max(400).nullish(),
  })
  .refine((v) => Object.keys(v).length > 0, { message: 'provide at least one field' });
export type UpdateBrandKit = z.infer<typeof updateBrandKitSchema>;
